import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

import { getNonce } from 'utils/getNonce'
import { shouldRetry } from 'utils/shouldRetry'

import type { ReactNode, FC } from 'react'

type Props = {
  children: ReactNode
}

export const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      retry: shouldRetry,
    },
    queries: {
      refetchOnWindowFocus: false,
      retry: shouldRetry,
      retryOnMount: process.env.NODE_ENV !== 'test',
      staleTime: Infinity,
    },
  },
})

export const QueryProvider: FC<Props> = ({ children }) => (
  <QueryClientProvider client={queryClient}>
    <div className="print:hidden">
      <ReactQueryDevtools
        styleNonce={getNonce()}
        initialIsOpen={false}
        position="bottom"
        buttonPosition="bottom-left"
      />
    </div>
    {children}
  </QueryClientProvider>
)
